import { FlowConsumerContextEnergy as FlowContext } from '../../context';

export const shouldSkipWhenUsageIsKnown = (context: FlowContext): boolean => {
  const { isUsageKnown } = context;

  return !!isUsageKnown;
};
